"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _twitter = _interopRequireDefault(require("./twitter.theme"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var twitter = {
  app: {
    atomicPublisherUnit: "user",
    atomicFollowerUnit: "follower"
  },
  brand: {
    codename: "twitter",
    name: "Twitter",
    color: _twitter["default"].tenant.primary,
    logoProps: {
      name: "twitterLogo"
    }
  },
  profile: {
    details: [{
      title: "Primary Category",
      dataKey: "category"
    }, {
      title: "Language",
      dataKey: "language_label"
    }],
    metrics: [{
      title: "SlateScore",
      dataKey: "slatescore",
      enclosed: true
    }, {
      title: "Subscribers",
      dataKey: "fan_count"
    }, {
      title: "Videos",
      dataKey: "video_count"
    }, {
      title: "Views",
      dataKey: "views_sum"
    }],
    videoMetrics: [{
      title: "VPV (Last 30)",
      dataKey: "views_per_video_last_30_days"
    }, {
      title: "Views (Last 30)",
      dataKey: "monthly_views"
    }, {
      title: "Likes Per Video",
      dataKey: "like_count_avg"
    }, {
      title: "Avg Length",
      dataKey: "duration_seconds_avg",
      type: "duration"
    }],
    videosGrid: {
      tabs: [{
        title: "Most Recent",
        icon: "today",
        dataKey: "mostRecent",
        order: "pub_date",
        query: {
          ordering: "-pub_date"
        }
      }, {
        title: "Most Engaging",
        icon: "thumb_up",
        dataKey: "mostEngaged",
        order: "engagement_count",
        query: {
          ordering: "-reaction_count"
        }
      }, {
        title: "High Risk",
        icon: "warning",
        dataKey: "highRisk",
        order: "risk_sort_only",
        query: {
          ordering: "-pub_date",
          brandsafety_video_label: "High Risk"
        }
      }],
      thumbnailMetrics: [{
        label: "Reactions",
        dataKey: "reaction_count",
        type: "number"
      }, {
        label: "Published",
        dataKey: "pub_date",
        type: "date"
      }]
    },
    videos: [{
      title: "Highest Risk",
      icon: "warning",
      dataKey: "highRisk",
      query: {
        order: "blended_bs_score",
        ordering: "-blended_bs_score,-pub_date",
        brandsafety_video_label: "High Risk"
      }
    }, {
      title: "Most Watched Videos",
      icon: "remove_red_eye",
      dataKey: "mostEngaged",
      query: {
        order: "engagement_count",
        ordering: "-view_count"
      }
    }, {
      title: "Most Recent Videos",
      icon: "today",
      dataKey: "mostRecent",
      query: {
        order: "pub_date",
        ordering: "-pub_date"
      }
    }],
    tags: {
      title: "Top Tags"
    }
  },
  mainCatalog: {
    headerColor: "blue",
    headerIcon: "ribbon",
    experimentalSearchEnabled: false,
    featuredMetrics: [{
      label: "Monthly Views",
      dataKey: "monthly_views_sum",
      icon: "views"
    }, {
      label: "Users",
      dataKey: "count",
      icon: "channel"
    }, {
      label: "Videos",
      dataKey: "video_count_sum",
      icon: "videosTriangle"
    }],
    facets: [{
      label: "Quality",
      filters: ["SlateScoreFilter"]
    }, {
      label: "Suitability Ratings",
      filters: ["SuitabilityFilter"],
      tooltip: "SuitabilityDescriptionList"
    }, {
      label: "Primary Category",
      filters: ["ContentCategoryFilter"]
    }, {
      label: "Audience",
      filters: ["FanCountFilter", {
        label: "Monthly Views",
        type: "MonthlyViewsFilter",
        queryParam: "monthly_views__range",
        aggregatesKey: "monthly_views"
      }, "LanguageFilter"]
    }],
    table: {
      defaultSortOrder: "-video_count",
      columns: [{
        dataKey: "picture",
        cellType: "picture"
      }, {
        label: "User Name",
        dataKey: "title",
        cellType: "title"
      }, {
        label: "SlateScore",
        dataKey: "unified_slatescore",
        cellType: "slateScore"
      }, {
        label: "Tweets",
        dataKey: "video_count",
        cellType: "number",
        "default": true
      }, {
        label: "Rating",
        dataKey: "suitability",
        cellType: "suitability"
      }, {
        label: "Followers",
        dataKey: "fan_count",
        cellType: "number"
      }, {
        label: "Language",
        dataKey: "language_label"
      }]
    }
  },
  videoCatalog: {
    header: {
      showHighRisk: {
        requiredPermissions: []
      }
    },
    table: {
      columns: [{
        dataKey: "thumbnail",
        cellType: "videoThumbnail"
      }, {
        label: "Title",
        dataKey: "title",
        cellType: "videoTitle"
      }, {
        label: "Publish Date",
        dataKey: "pub_date",
        cellType: "date"
      }, {
        label: "Risk Flag",
        dataKey: "brandsafety_video_label",
        cellType: "highRiskFlag"
      }]
    }
  },
  videoPlayer: {
    videoStats: [{
      label: "Likes",
      dataKey: "like_count"
    }, {
      label: "Views",
      dataKey: "view_count"
    }, {
      label: "Comments",
      dataKey: "comment_count"
    }],
    externalLink: {
      label: "View on Twitter",
      iconProps: {
        name: "twitterLogo"
      }
    }
  },
  charts: {
    publishingCadence: {
      title: "Publishing Cadence",
      subheading: "Videos published over the last 12 weeks (by week)",
      legendOverallAvg: "Platform Avg.",
      legendThisPage: "This User",
      legendPrimaryCateory: "Users with Same Primary Category",
      yAxisLabel: "Number of videos",
      xAxisLabel: "Weeks"
    },
    length: {
      title: "Avg Video Length",
      subheading: "Average video length in seconds",
      xAxisLabel: "Video length (sec.)",
      verbosedLabels: {
        _page: "This User",
        _category: "Users with Same Primary Category",
        _all: "Platform Avg."
      }
    },
    engagements: {
      title: "Avg Video Engagements",
      subheading: "Sum of likes, dislikes and comments per video",
      xAxisLabel: "Number of likes, dislikes and comments",
      verbosedLabels: {
        _page: "This User",
        _category: "Users with Same Primary Category",
        _all: "Platform Avg."
      }
    }
  },
  navigationMenu: [{
    label: "DV Content Settings",
    iconProps: {
      name: "contentRatings"
    },
    routeRef: "mainCatalog",
    routeRefMatches: ["mainCatalog", "profile", "profileVideos"]
  }],
  routes: {
    home: {
      url: "/",
      title: "Home"
    },
    mainCatalog: {
      url: "/users",
      title: "DV Content Settings",
      component: "MainCatalog",
      "default": true
    },
    profile: {
      url: "/user/:id",
      title: "DV Content Settings",
      component: "Profile"
    },
    profileVideos: {
      url: "/user/:id/videos",
      title: "DV Content Settings",
      component: "Profile"
    }
  }
};
var _default = exports["default"] = twitter;